import {
    LOAD_METRICS_FOR_CART_CALL_BEGIN,
    LOAD_METRICS_FOR_CART_CALL_FAILURE,
    LOAD_STOW_PACKAGE_METRICS_FOR_CART
} from "../actions/CartActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    stowPackageMetricsMap: {}
}

/**
 * Reducer function for Cart View that changes state
 * based on the action triggered.
 */
export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_CART_CALL_BEGIN:
            return {
                ...state,
                loading: true
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_CART:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_METRICS_FOR_CART_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/CartReducer.js